import React from 'react';
import { useNavigate } from 'react-router-dom';
import './SignUpSuccess.css';
import logo from '../../assets/images/logo.png';
import loginBg from '../../assets/images/login-bg.jpg';

function SignUpSuccess() {
    const navigate = useNavigate();

    return (
        <div className="success-page-container">
            <div className="success-header" style={{ backgroundImage: `url(${loginBg})` }}>
            </div>

            <div className="success-card-wrapper">
                <div className="header-content">
                    <img src={logo} alt="brainyclock" className="logo-white" />
                </div>
                <div className="success-card">
                    <div className="check-icon-container">
                        {/* <div className="check-icon"> */}
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_322_403)">
                                    <rect width="40" height="40" rx="20" fill="#E7E6AD" />
                                    <path d="M17.5501 26L11.8501 20.3L13.2751 18.875L17.5501 23.15L26.7251 13.975L28.1501 15.4L17.5501 26Z" fill="#49491E" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_322_403">
                                        <rect width="40" height="40" rx="20" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>

                        {/* </div> */}
                    </div>

                    <h2 className="card-title">Your account is ready</h2>

                    <p className="success-text">
                        You've successfully created your BrainyClock account.
                        You're on the Free plan and can add up to 3 employees at no cost.
                    </p>

                    <button
                        className="btn-dashboard"
                        onClick={() => window.open("https://portal.brainyclock.com", "_blank")}
                    >
                        Go to dashboard
                    </button>

                    <p className="upgrade-hint">
                        You can upgrade anytime as your team grows.
                    </p>
                </div>
            </div>
        </div>
    );
}

export default SignUpSuccess;
